import React from "react";

const LuxuryCarOne = () => {
  return (
    <section className="luxury-car-one luxury-car-one--two section- py-5">
      <div className="container">
        <div className="row gutter-y-60">
          <div className="col-lg-6">
            <div className="luxury-car-one__content">
              <div className="sec-title sec-title--two text-start">
                <h6 className="sec-title__tagline bw-split-in-right">
                  PREMIUM TRAVEL SERVICES
                </h6>
                <h3 className="sec-title__title bw-split-in-left">
                  Experience Luxury Travel with Sanavi Travels
                </h3>
              </div>

              <p
                className="luxury-car-one__text wow fadeInUp"
                data-wow-duration="1500ms"
                data-wow-delay="100ms"
              >
                Sanavi Travels offers a premium fleet of luxury cars designed to
                provide maximum comfort, elegance, and reliability. Whether it’s
                airport transfers, business travel, weddings, or outstation
                trips, we ensure a smooth and classy travel experience.
              </p>

              <div className="luxury-car-one__feature">
                <div
                  className="luxury-car-one__feature__list wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <div className="luxury-car-one__feature__list__icon">
                    <i className="icon-check1"></i>
                  </div>
                  <div className="luxury-car-one__feature__list__content">
                    <h5 className="luxury-car-one__feature__list__title">
                      On-Time Pickup & Drop
                    </h5>
                    <p className="luxury-car-one__feature__list__text">
                      Our professional drivers ensure punctual pickups and timely
                      drop-offs, so you never have to worry about delays.
                    </p>
                  </div>
                </div>

                {/* <div
                  className="luxury-car-one__feature__list wow fadeInUp"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="luxury-car-one__feature__list__icon">
                    <i className="icon-check1"></i>
                  </div>
                  <div className="luxury-car-one__feature__list__content">
                    <h5 className="luxury-car-one__feature__list__title">
                      Premium & Well-Maintained Cars
                    </h5>
                    <p className="luxury-car-one__feature__list__text">
                      Travel in clean, air-conditioned, and well-maintained
                      luxury vehicles that offer a relaxing and enjoyable ride.
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
          </div>

          <div className="col-lg-6 d-none d-md-block">
            <div
              className="luxury-car-one__carousel wow fadeInRight"
              data-wow-duration="1500ms"
              data-wow-delay="300ms"
            >
              <div
                className="luxury-car-one__carousel__bg"
                style={{
                  backgroundImage:
                    "url(/images/resources/car-carousel-bg.png)",
                }}
              ></div>

              <div
                className="luxury-car-one__carousel__inner rentol-owl__carousel owl-carousel owl-theme d-none d-md-block"
                data-owl-options={`{
                  "items": 1,
                  "margin": 30,
                  "loop": false,
                  "smartSpeed": 700,
                  "nav": false,
                  "navText": ["<i class=\\"icon-right-arrow\\"></i>","<i class=\\"icon-right-arrow\\"></i>"],
                  "dots": true,
                  "autoplay": false
                }`}
              >
                <div className="luxury-car-one__item ">
                  <img
                    src="/images/resources/car-carousel-1-1.png"
                    alt="Sanavi Travels luxury car" className=""
                  />
                </div>

                {/*
                <div className="luxury-car-one__item">
                  <img
                    src="/images/resources/car-carousel-1-2.png"
                    alt="Sanavi Travels premium vehicle"
                  />
                </div>
                */}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="luxury-car-one__element">
        <img src="/images/shapes/shape-2-2.png" alt="" />
      </div>

      <div className="luxury-car-one__element-two">
        <img src="/images/shapes/shape-2-3.png" alt="" />
      </div>
    </section>
  );
};

export default LuxuryCarOne;
